/**
 * PWK variant auto-resolver.
 *
 * Reads the inline variant mapping rendered by pwk-variant-resolver.liquid,
 * detects the customer's locale, and pre-selects the correct variant id on
 * the cart-form before "Add to cart". Best-effort by design: server-side
 * PwkOrderSkuResolver is the authoritative correction layer for shipping
 * country mismatches.
 */
(function () {
  var mapEl = document.getElementById('pwk-variant-map');
  if (!mapEl) return;

  var data;
  try {
    data = JSON.parse(mapEl.textContent);
  } catch (err) {
    console.warn('[pwk-variant-resolver] invalid mapping JSON', err);
    return;
  }

  // Country → region mapping. Mirrors fulfillment routing in the dashboard:
  // EU = European/EFTA countries; US = US/CA/MX; UK = GB; CH = CH/LI; AU = AU/NZ.
  var COUNTRY_TO_REGION = {
    BE: 'EU', NL: 'EU', DE: 'EU', FR: 'EU', IT: 'EU', ES: 'EU', PT: 'EU',
    AT: 'EU', IE: 'EU', LU: 'EU', FI: 'EU', GR: 'EU', CZ: 'EU', PL: 'EU',
    HU: 'EU', SK: 'EU', SI: 'EU', EE: 'EU', LT: 'EU', LV: 'EU', BG: 'EU',
    RO: 'EU', MT: 'EU', CY: 'EU', HR: 'EU', DK: 'EU', SE: 'EU', IS: 'EU',
    NO: 'EU',
    US: 'US', CA: 'US', MX: 'US',
    GB: 'UK',
    CH: 'CH', LI: 'CH',
    AU: 'AU', NZ: 'AU',
  };

  function detectCountry() {
    if (window.cyclowaxCustomerCountry && COUNTRY_TO_REGION[window.cyclowaxCustomerCountry]) {
      return window.cyclowaxCustomerCountry;
    }
    try {
      var stored = localStorage.getItem('cyclowax_country');
      if (stored && COUNTRY_TO_REGION[stored]) return stored;
    } catch (e) { /* localStorage may be unavailable */ }
    if (window.Shopify && window.Shopify.country) {
      var sc = String(window.Shopify.country).toUpperCase();
      if (COUNTRY_TO_REGION[sc]) return sc;
    }
    if (window.Shopify && window.Shopify.locale) {
      var localeParts = String(window.Shopify.locale).toUpperCase().split('-');
      if (localeParts.length > 1 && COUNTRY_TO_REGION[localeParts[1]]) return localeParts[1];
    }
    if (navigator.language) {
      var navParts = String(navigator.language).toUpperCase().split('-');
      if (navParts.length > 1 && COUNTRY_TO_REGION[navParts[1]]) return navParts[1];
    }
    return 'BE';
  }

  function detectRegion() {
    var country = detectCountry();
    return COUNTRY_TO_REGION[country] || 'EU';
  }

  function detectPhase() {
    var cutoff = new Date(data.phase_cutoff_iso);
    return new Date() < cutoff ? 'PH1' : 'PH2';
  }

  function pickVariant(region, phase) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (v.region === region && v.phase === phase) return v;
    }
    return null;
  }

  function setSelectValue(form, optionName, value) {
    var selector = 'select[name="options[' + optionName + ']"]';
    var sel = form.querySelector(selector);
    if (sel) {
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var radioName = 'input[type="radio"][name="options[' + optionName + ']"]';
    var radios = form.querySelectorAll(radioName);
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function applySelection() {
    var region = detectRegion();
    var phase = detectPhase();
    var variant = pickVariant(region, phase);

    if (!variant) {
      console.warn('[pwk-variant-resolver] no variant matched', { region: region, phase: phase });
      return;
    }

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      setSelectValue(forms[i], 'Region', variant.region);
      setSelectValue(forms[i], 'Phase', variant.phase);
    }

    try {
      var country = detectCountry();
      localStorage.setItem('cyclowax_country', country);
    } catch (e) { /* ignore */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySelection);
  } else {
    applySelection();
  }
})();
